import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent(
      'PaginatedGridGallery',
      () => {
        return Promise.all([
          import(
            './viewer/skinComps/PaginatedGridDefaultSkin/PaginatedGridDefaultSkin.skin' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridDefaultSkin" */
          ),
          import(
            './viewer/PaginatedGridGallery.controller' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridDefaultSkin" */
          ),
        ]).then(([componentModule, controllerModule]) => {
          return {
            component: componentModule.default,
            controller: controllerModule.default,
          };
        });
      },
      'PaginatedGridDefaultSkin',
    );

    hostAPI.registerComponent(
      'PaginatedGridGallery',
      () => {
        return Promise.all([
          import(
            './viewer/skinComps/PaginatedGridArrowsOutside/PaginatedGridArrowsOutside.skin' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridArrowsOutside" */
          ),
          import(
            './viewer/PaginatedGridGallery.controller' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridArrowsOutside" */
          ),
        ]).then(([componentModule, controllerModule]) => {
          return {
            component: componentModule.default,
            controller: controllerModule.default,
          };
        });
      },
      'PaginatedGridArrowsOutside',
    );

    hostAPI.registerComponent(
      'PaginatedGridGallery',
      () => {
        return Promise.all([
          import(
            './viewer/skinComps/PaginatedGridRibbonArrows/PaginatedGridRibbonArrows.skin' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridRibbonArrows" */
          ),
          import(
            './viewer/PaginatedGridGallery.controller' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridRibbonArrows" */
          ),
        ]).then(([componentModule, controllerModule]) => {
          return {
            component: componentModule.default,
            controller: controllerModule.default,
          };
        });
      },
      'PaginatedGridRibbonArrows',
    );
    hostAPI.registerComponent(
      'PaginatedGridGallery',
      () => {
        return Promise.all([
          import(
            './viewer/skinComps/PaginatedGridTextBottom/PaginatedGridTextBottom.skin' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridTextBottom" */
          ),
          import(
            './viewer/PaginatedGridGallery.controller' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridTextBottom" */
          ),
        ]).then(([componentModule, controllerModule]) => {
          return {
            component: componentModule.default,
            controller: controllerModule.default,
          };
        });
      },
      'PaginatedGridTextBottom',
    );
    hostAPI.registerComponent(
      'PaginatedGridGallery',
      () => {
        return Promise.all([
          import(
            './viewer/skinComps/PaginatedGridOverlay/PaginatedGridOverlay.skin' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridOverlay" */
          ),
          import(
            './viewer/PaginatedGridGallery.controller' /* webpackChunkName: "PaginatedGridGallery_PaginatedGridOverlay" */
          ),
        ]).then(([componentModule, controllerModule]) => {
          return {
            component: componentModule.default,
            controller: controllerModule.default,
          };
        });
      },
      'PaginatedGridOverlay',
    );
  },
};

export default entry;
